module.exports = __webpack_public_path__ + "img/projects-active.45a66b79.svg";